export default "__VITE_ASSET__BgQB3jjC__"